const BACKEND_URL = "https://hms-byaman.herokuapp.com";
const hello=()=>{

}

export {BACKEND_URL,hello};
